import React from "react";
import PropTypes from "prop-types";
import { getColor } from "@gc-npm/utils.enums.colors";
import TextInfo from "@gc-npm/components.text";
import CardTemplate from "@/home_components/card/card-template";
import CustomLink from "@gc-npm/components.custom-link";
import Image from "@gc-npm/components.c-image";

const extraerTextoSpan = (cadena) => {
  const patron = /<span[^>]*>(.*?)<\/span>/;
  const elementoEncapsulado = patron.test(cadena);
  if (elementoEncapsulado) {
    const resultado = cadena.match(patron);
    if (resultado) {
      return resultado[1];
    } else {
      null;
    }
  }
  return cadena;
};

const makeUpComoponentPerso = (taggingInfo) => {
  if (taggingInfo && taggingInfo.componentPerso) {
    return JSON.stringify(taggingInfo.componentPerso);
  }
  return "";
};

const comprobarComponentVariation = (taggingInfo, link) => {
  if (taggingInfo && taggingInfo.componentVariation) {
    return taggingInfo.componentVariation;
  } else if (link && link.componentVariation) {
    return link.componentVariation;
  }
  return "all";
};

const computeBackgroundColor = (color) => {
  if (color && typeof color === "string") {
    if (color.charAt(0) === "#") {
      return color;
    } else {
      return getColor(color);
    }
  }
  return getColor(color);
};

const Card = (restProps) => {
  const {
    layout,
    backgroundColor,
    skeletonClassName,
    className,
    cardShadow,
    backgroundOpacity,
    children,
    setPriority = false,
    imageAspectRatio,
    finalFetch,
    sizes
  } = restProps;

  // console.log({
  //   setPriority
  // })
  const titleCusto = restProps["Text-2"]?.text || restProps["Text-1"]?.text;
  const link = restProps["CustomLink-1"]?.text;
  const backgroundImg = restProps["Image-1"];
  const video = restProps["Video-1"];
  let finalClassName = className;
  // const imgBackground = {
  //   desktop: restProps["Image-1"],
  //   tablet: restProps["Image-tablet"],
  //   mobile: restProps["Image-mobile"],
  // };

  /* EDITING MODE BEGINS */
  let DetailBar = null;
  let editableClassName = "card-column";
  /* EDITING MODE ENDS */
  var taggingInfo;
  try {
    taggingInfo = restProps.taggingInfo && {
      ...restProps.taggingInfo,
      componentVariation: comprobarComponentVariation(
        restProps.taggingInfo,
        link
      ),
      componentContent: extraerTextoSpan(titleCusto),
      componentPerso: makeUpComoponentPerso(restProps.taggingInfo),
      eventType: "click",
    };
  } catch (err) {}

  const computeBackgroundColor = (color) => {
    // console.log("color: ", color);
    if (color && typeof color === "string") {
      if (color.charAt(0) === "#") {
        return color;
      } else {
        return getColor(color);
      }
    }
    return getColor(color);
  };

  const cardStyle = {
    backgroundColor: computeBackgroundColor(backgroundColor),
  };

  if (cardShadow && cardShadow != "false" && cardShadow != false) {
    finalClassName =
      finalClassName + ` card-shadow--${layout === "dispo-product" ? 1 : 10}`;
  }

  return (
    <>
      <CustomLink
        {...restProps["CustomLink-1"]}
        title={restProps["CustomLink-1"]?.title || ""}
        taggingInfo={taggingInfo}
        className="card-clickable"
        cyData="Card CustomLink-1"
      >
        <div className={editableClassName}>
          {DetailBar}
          {restProps["Text-0"] && restProps["Text-0"].text && (
            <div className="card-title">
              <TextInfo
                {...restProps["Text-0"]}
                cyData="Card TV Text-0"
              />
            </div>
          )}

          <div
            className={`card layout-${layout} ${finalClassName}`}
            style={cardStyle}
          >
            <>
              {video && video.src && (
                <div
                  className="video"
                  dangerouslySetInnerHTML={{
                    __html: `
            <video muted autoplay loop playsinline> 
                <source src="${video.src}" alt="${video.alt}" type="video/webm"></source>
                <source src="${video.srcMp4}" alt="${video.alt}" type="video/mp4"></source>
            </video>
            `,
                  }}
                ></div>
              )}
              {backgroundImg && backgroundImg.src && (
                <div className={`card-backgroundImg-1`} aria-hidden="true">
                  <Image
                    {...backgroundImg}
                    priority={setPriority}
                    fill
                    objectFit={backgroundImg.objectFit || "cover"}
                    sizes={sizes}
                    cyData={`Card Image-1 ${backgroundImg.alt}`}                   
                  />
                  {!!backgroundOpacity && (
                    <div className="card-img--opacity"></div>
                  )}
                </div>
              )}
              {(
                <div className="card-container">
                  {children && console.log('Children:', children)}
                  {children && children}
                  {!children && (
                    <CardTemplate
                      {...restProps}
                      setPriority={setPriority}
                      finalFetch={finalFetch}                     
                    />
                  )}
                </div>
              )}
            </>
            <div className={skeletonClassName} />
          </div>

        
        </div>
      </CustomLink>
      <style jsx>
        {`.card-title {
  margin-bottom: 1rem;
}`}
      </style>
    </>
  );
};

Card.propTypes = {
  layout: PropTypes.string,
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
};

Card.defaultProps = {
  layout: "capta",
  backgroundColor: "transparent",
  className: "",
};

export default Card;
